import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../Reducks/SessionDetails';
import { actions as registrantActions } from '../../../Reducks/SessionRegistrants';
import { actions as attendeeActions } from '../../../Reducks/SessionAttendees';
import { withRouter } from 'react-router';
import SessionDetailsStats from './Stats/SessionDetailsStats';
import PropTypes from 'prop-types';
import './SessionDetailsContainer.css';
import AttendanceConversionChart from './Chart/AttendanceConversionChart';
import AttendeesInSessionChart from './Chart/AttendeesInSessionChart';
import { NavLink } from 'react-router-dom';
import { getFormattedInterval } from '../../../Utils/DateFormatUtils';
import { getWebinarType } from './Utils/SessionDetailsUtil';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import AttendeesTable from './Table/AttendeesTable/AttendeesTable';
import RegistrantsTable from './Table/RegistrantsTable/RegistrantsTable';
import {
  RobotMessageState,
  EXPERIENCED_TYPE_SIMULIVE,
  RECURRENCE_PERIOD_SIMULIVE,
  SessionDetailsTableType
} from '../../../Utils/Constants';
import AttendeeInterestTable from './Table/AttendeeInterestTable/AttendeeInterestTable';
import RobotMessageComponent from '../../../Components/RobotMessageComponent/RobotMessageComponent';
import { AnalyticsTypeSwitcher, LIVE } from '../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import {
  trackAdminAnalyticsSessionDetails,
  trackAnalyticsTypeSwitcher
} from '../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { sessionsDetailsDesktopSkeletonScreen } from '../../../SkeletonScreens/SkeletonScreen';
import EngagementPanel from './Engagement/EngagementPanel';
import WebinarTypeText from '../../../Components/WebinarTypeText/WebinarTypeText';
import TabBar from '../../../Components/TabBar/TabBar';
import { getTrimString } from '../../../Utils/StringUtils';
import moment from 'moment-timezone';
import AppConstants from '../../../AppConstants';

export class SessionDetailsContainer extends Component {
  componentDidMount() {
    const { match, getSessionDetails, isAdmin } = this.props;
    getSessionDetails(match.params.sessionKey);
    this.props.requestRegistrants(match.params.sessionKey);
    this.props.requestAttendees(match.params.sessionKey);
    window.scrollTo(0, 0);
    if (isAdmin) {
      trackAdminAnalyticsSessionDetails(LIVE, match.params.sessionKey);
    } else {
      trackAnalyticsTypeSwitcher(AnalyticsTypeSwitcher.SESSION_DETAILS);
    }
  }

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    isBig: PropTypes.bool,
    isAdmin: PropTypes.bool,
    accountKey: PropTypes.string,
    reduced_session_details: PropTypes.object,
    getSessionDetails: PropTypes.func,
    requestRegistrants: PropTypes.func,
    requestAttendees: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      activeTab: SessionDetailsTableType.REGISTRANTS
    };
  }

  render() {
    const { sessionDetails, fetching, error } = this.props.reduced_session_details;
    const { isBig } = this.props;
    const { sessionKey, webinarKey } = sessionDetails || {};

    if (fetching) {
      return <div className="sessionDetails">{sessionsDetailsDesktopSkeletonScreen()}</div>;
    } else if (error) {
      const errorStateType =
        error.response && [403, 404].includes(error.response.status)
          ? RobotMessageState.NOT_FOUND_STATE
          : RobotMessageState.ERROR_STATE;
      return <RobotMessageComponent type={errorStateType} />;
    }

    const webinarNameHeading = <WebinarNameHeading sessionDetails={sessionDetails} />;

    const desktopView = sessionDetails !== null && (
      <div className="sessionDetailsDesktop">
        <div className="breadCrumbRow">
          <div>{this.breadCrumbAndDownloadComponent()}</div>
          <div>{webinarNameHeading}</div>
        </div>
        {SessionDetailsContainer.isSessionProcessing(sessionDetails) ? (
          <RobotMessageComponent type={RobotMessageState.SESSION_PROCESSING_STATE} />
        ) : (
          <React.Fragment>
            <div className="statsRow">{this.webinarSessionStatsComponent()}</div>
            <div className="dualPanelRow">
              {<AttendanceConversionChart />}
              {this.numberOfAttendeesInSessionChartComponent()}
            </div>
            <div className="dualPanelRow">
              {this.engagementPanelComponent(webinarKey, sessionKey, webinarNameHeading)}
              {this.mostInterestedAttendeesComponent()}
            </div>
            {this.registrantAndAttendeesTableComponent(sessionKey)}
          </React.Fragment>
        )}
      </div>
    );
    const mobileView = sessionDetails !== null && (
      <div className="sessionDetailsMobile">
        {this.breadCrumbAndDownloadComponent()}
        {webinarNameHeading}
        {SessionDetailsContainer.isSessionProcessing(sessionDetails) ? (
          <RobotMessageComponent type={RobotMessageState.SESSION_PROCESSING_STATE} />
        ) : (
          <React.Fragment>
            {this.webinarSessionStatsComponent()}
            {<AttendanceConversionChart />}
            {this.numberOfAttendeesInSessionChartComponent()}
            {this.engagementPanelComponent(webinarKey, sessionKey, webinarNameHeading)}
            {this.mostInterestedAttendeesComponent()}
            {this.registrantAndAttendeesTableComponent(sessionKey)}
          </React.Fragment>
        )}
      </div>
    );

    return <div className="sessionDetails">{isBig ? desktopView : mobileView}</div>;
  }

  static isSessionProcessing(sessionDetails) {
    return moment().valueOf() - moment(sessionDetails.endTime) < AppConstants.SESSION_PROCESSING_MESSAGE_TIME_IN_MILLIS;
  }

  breadCrumbAndDownloadComponent = () => {
    const { t } = this.context;
    const { sessionDetails } = this.props.reduced_session_details;
    const { isBig, isAdmin, accountKey } = this.props;
    const path = isAdmin ? `/analytics/accounts/${accountKey}/sessions` : '/analytics/sessions';
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div className="overview d-inline-flex">
          <Breadcrumb>
            <BreadcrumbItem>
              <NavLink to={path} onClick={() => trackAnalyticsTypeSwitcher(AnalyticsTypeSwitcher.LIVE)}>
                {t('header.overview')}
              </NavLink>
            </BreadcrumbItem>
            <BreadcrumbItem active>{getTrimString(sessionDetails.webinarName, isBig ? 32 : 16)}</BreadcrumbItem>
          </Breadcrumb>
        </div>
        {isBig && (
          <button
            className="custom-buttons-chameleon outline-button"
            onClick={() => {
              document.title = t('sessionDetails.sessionDetailsGeneratedOn') + new Date().toLocaleString();
              window.print();
              document.title = 'GoToWebinar | Analytics';
            }}>
            {t('buttons.downloadCamelCase')}
          </button>
        )}
      </div>
    );
  };
  webinarSessionStatsComponent = () => {
    const { stats } = this.props.reduced_session_details;
    const { isBig } = this.props;

    return (
      <SessionDetailsStats
        isBig={isBig}
        attendees={stats.attendees}
        avgInterestRating={stats.averageInterestRating}
        totalAverageAttentiveness={stats.averageAttentiveness}
        registrants={stats.registrants}
      />
    );
  };

  numberOfAttendeesInSessionChartComponent = () => {
    const { attendeesInSessionInfoOverTime } = this.props.reduced_session_details;

    let displayAttendeesInSessionChart = this.displayAttendeesInSessionChart(attendeesInSessionInfoOverTime);

    return <div>{displayAttendeesInSessionChart && <AttendeesInSessionChart />}</div>;
  };

  engagementPanelComponent = (webinarKey, sessionKey, webinarNameHeading) => {
    const { isBig } = this.props;
    return (
      <div className="engagementPanel">
        <EngagementPanel
          isBig={isBig}
          webinarNameHeading={webinarNameHeading}
          webinarKey={webinarKey}
          sessionKey={sessionKey}
        />
      </div>
    );
  };

  mostInterestedAttendeesComponent = () => {
    return (
      <div className="attendeeInterestTable">
        <AttendeeInterestTable />
      </div>
    );
  };

  registrantAndAttendeesTableComponent = sessionKey => {
    const { t } = this.context;
    const { activeTab } = this.state;
    const { isBig } = this.props;
    const tabOptions = [
      { id: SessionDetailsTableType.REGISTRANTS, title: t('tableHeaderColumns.registrants') },
      { id: SessionDetailsTableType.ATTENDEES, title: t('tableHeaderColumns.attendees') }
    ].map(option => {
      return { ...option, onClick: () => this.setState({ activeTab: option.id }) };
    });

    return (
      <div className="registrantAttendeeTable">
        <TabBar activeTabId={activeTab} tabContentMetadata={tabOptions} />
        {activeTab === SessionDetailsTableType.REGISTRANTS ? (
          <RegistrantsTable sessionKey={sessionKey} isBig={isBig} />
        ) : (
          <AttendeesTable sessionKey={sessionKey} isBig={isBig} />
        )}
      </div>
    );
  };

  displayAttendeesInSessionChart = attendeesInSessionInfoOverTime => {
    if (
      attendeesInSessionInfoOverTime.attendeeCountsOverTime &&
      attendeesInSessionInfoOverTime.attendeeCountsOverTime.length > 0
    ) {
      return (
        !(attendeesInSessionInfoOverTime.experienceType === EXPERIENCED_TYPE_SIMULIVE) ||
        !(attendeesInSessionInfoOverTime.recurrencePeriod === RECURRENCE_PERIOD_SIMULIVE)
      );
    } else {
      return false;
    }
  };
}

const WebinarNameHeading = ({ sessionDetails = {} }) => {
  return (
    <div className="webinarNameHeading">
      <WebinarTypeText type={getWebinarType(sessionDetails.experienceType)} />
      <div className="title">{sessionDetails.webinarName}</div>
      <div className="subTitle">
        {getFormattedInterval(sessionDetails.startTime, sessionDetails.endTime, sessionDetails.timeZone)}
      </div>
    </div>
  );
};

export default withRouter(
  connect(
    state => ({
      reduced_session_details: state.reduced_session_details
    }),
    {
      getSessionDetails: actions.getSessionDetails,
      requestRegistrants: registrantActions.getSessionRegistrantsDetails,
      requestAttendees: attendeeActions.getSessionAttendeesDetails
    }
  )(SessionDetailsContainer)
);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/SessionDetailsContainer.js